<template>
    <div class="notifications-container">
        <el-card v-for="(note, index) in notifications" :key="index" class="notification full-width-card">
            <h4>{{ note.title }}</h4>
            <p>{{ note.text }}</p>
            <span class="date">{{ note.date }}</span>
        </el-card>
    </div>
</template>

<script>
export default {
    name: 'NotificationsPage',
    data() {
        return {
            notifications: [
                {
                    title: 'Обновление системы',
                    text: 'Система была успешно обновлена до версии 1.2.0.',
                    date: '13 мая 2025'
                },
                {
                    title: 'Новый пациент добавлен',
                    text: 'Вы успешно добавили нового пациента в систему.',
                    date: '12 мая 2025'
                },
                {
                    title: 'Изменения в графике',
                    text: 'Ваш рабочий график изменён. Подробности в личном кабинете.',
                    date: '11 мая 2025'
                }
            ]
        }
    }
}
</script>

<style scoped>
.notifications-container {
    padding: 20px;
}

.full-width-card {
    width: 100%;
    margin-bottom: 15px;
    box-sizing: border-box;
}

.date {
    display: block;
    font-size: 12px;
    color: gray;
    margin-top: 5px;
}
</style>